import { ReactNode } from 'react';
import styles from './WidgetTile.module.css';

interface WidgetTileProps {
  title: string;
  children: ReactNode;
}

const WidgetTile = ({ title, children }: WidgetTileProps) => {
  return (
    <article className={styles.widgetTile}>
      <div className={styles.details}>
        <h4 className={styles.title}>{title}</h4>
        {children}
      </div>
    </article>
  );
};

export default WidgetTile;
